import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {BaseTintColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemTintColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemTintColor = useGetKeyFromEffectsActiveItem('tintColor');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || !activeItemTintColor) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateTintColor = (tintColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          tintColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseTintColorPanel tintColor={activeItemTintColor} onUpdateTintColor={updateTintColor} />;
}
